import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../Generic/Button';
import Typography from '../../Generic/Typography';
import styles from './Menu-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';

class MenuListDT extends React.Component {
  render() {
    const { menuSlots, resetMenu } = this.props;
    return (
      <>
        <div className={classNames(styles.columnOne)}>
          {menuSlots.menuItemsCollection.items.map((menuitem, i) => {
            if (menuitem && menuitem.column === i18nMessages.one) {
              return (
                <li className={classNames(styles.subMenuList)} key={i}>
                  {getMenuList(i, menuitem, resetMenu)}
                </li>
              );
            }
          })}
        </div>
        <div className={classNames(styles.columnTwo)}>
          {menuSlots.menuItemsCollection.items.map((menuitem, i) => {
            if (menuitem && menuitem.column === i18nMessages.two) {
              return (
                <li className={classNames(styles.subMenuList)} key={i}>
                  {getMenuList(i, menuitem, resetMenu)}
                </li>
              );
            }
          })}
        </div>
        <div className={classNames(styles.columnThree)}>
          {menuSlots.menuItemsCollection.items.map((menuitem, i) => {
            if (menuitem && menuitem.column === i18nMessages.three) {
              return (
                <li className={classNames(styles.subMenuList)} key={i}>
                  {getMenuList(i, menuitem, resetMenu)}
                </li>
              );
            }
          })}
        </div>
      </>
    );
  }
}
MenuListDT.propTypes = {
  menuSlots: PropTypes.oneOfType([PropTypes.object]),
  resetMenu: PropTypes.func.isRequired,
};
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const MenuListDT = ({prop = val, menuSlots = { }) =>
MenuListDT.defaultProps = {
  menuSlots: {},
};
export default MenuListDT;
export const getMenuList = (index, menuitem, resetMenu) => {
  return (
    <Button
      key={index}
      to={menuitem.menuLink}
      className={classNames(styles.subMenuLinks)}
      onClick={resetMenu}
      tabIndex={0}
    >
      <Typography
        key={index}
        component="div"
        className={classNames(styles.subMenuListText, menuitem.styles)}
        dangerouslySetInnerHTML={{
          __html:DOMPurify.sanitize( menuitem.menuText),
        }}
      />
    </Button>
  );
};
